module.exports = "<div class=\"y-box\">\n  <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/box/index.html
// module id = 214
// module chunks = 0